import { getSearchLocationSuggestions, getCurLocationSuggestion, getCurLatlon } from "../../services/MainService";
const state = {
  searchLocationSuggestions: [],
  curLocationSuggestion: [],
  curLatlon: {},
};
const getters = {
  allLocationSuggestions: (state) => state.searchLocationSuggestions,
  currentLocSuggestion: (state) => state.curLocationSuggestion,
  currentLatlon: (state) => state.curLatlon,
};
const actions = {
  async fetchLocationSuggestions({ commit }, val) {
    await getSearchLocationSuggestions(val)
      .then((res) => res.data)
      .then((res) => {
        commit("setLocationSuggestions", res);
      });
  },
  async fetchCurLocationSuggestion({ commit }, val) {
    await getCurLocationSuggestion(val)
      .then((res) => res.data)
      .then((res) => {
        commit("setCurLocationSuggestion", res);
      });
  },
  async fetchCurLatlon({ commit }, val) {
    await getCurLatlon(val)
      .then((res) => res.data)
      .then((res) => {
        commit("setCurLatlon", res);
      });
  },
};
const mutations = {
    setLocationSuggestions: (state, searchLocationSuggestions) =>
    (state.searchLocationSuggestions = searchLocationSuggestions),
    setCurLocationSuggestion: (state, curLocationSuggestion) =>
    (state.curLocationSuggestion = curLocationSuggestion),
    setCurLatlon: (state, curLatlon) =>
    (state.curLatlon = curLatlon),
};
export default {
  state,
  getters,
  actions,
  mutations,
};
